import { defineStore } from 'pinia'

const TYRO_SETTINGS_KEY = 'tyro_settings'

export const useTyroStore = defineStore('tyro-store', {
  state: () => ({
    integratedSurcharge: true,
    printCustomerCopy: true,
    printMerchantCopy: true,
  }),

  getters: {
    settings: (state) => ({
      integratedReceipt: true,
      integratedSurcharge: state.integratedSurcharge,
      printCustomerCopy: state.printCustomerCopy,
      printMerchantCopy: state.printMerchantCopy,
    }),
  },

  actions: {
    loadSettings() {
      try {
        const saved = localStorage.getItem(TYRO_SETTINGS_KEY)
        if (saved) {
          const parsed = JSON.parse(saved)
          this.integratedSurcharge = parsed.integratedSurcharge ?? true
          this.printCustomerCopy = parsed.printCustomerCopy ?? true
          this.printMerchantCopy = parsed.printMerchantCopy ?? true
        }
        console.log('[TyroStore] Settings loaded:', this.settings)
      } catch (e) {
        console.error('[TyroStore] Failed to load settings:', e)
      }
    },

    saveSettings() {
      try {
        localStorage.setItem(TYRO_SETTINGS_KEY, JSON.stringify({
          integratedReceipt: true,
          integratedSurcharge: this.integratedSurcharge,
          printCustomerCopy: this.printCustomerCopy,
          printMerchantCopy: this.printMerchantCopy,
        }))
        console.log('[TyroStore] Settings saved:', this.settings)
        return true
      } catch (e) {
        console.error('[TyroStore] Failed to save settings:', e)
        return false
      }
    },

    setIntegratedSurcharge(value) {
      this.integratedSurcharge = value
      this.saveSettings()
    },

    setPrintCustomerCopy(value) {
      this.printCustomerCopy = value
      this.saveSettings()
    },

    setPrintMerchantCopy(value) {
      this.printMerchantCopy = value
      this.saveSettings()
    },

    updateSettings(settings) {
      if (settings.integratedSurcharge !== undefined) {
        this.integratedSurcharge = settings.integratedSurcharge
      }
      if (settings.printCustomerCopy !== undefined) {
        this.printCustomerCopy = settings.printCustomerCopy
      }
      if (settings.printMerchantCopy !== undefined) {
        this.printMerchantCopy = settings.printMerchantCopy
      }
      this.saveSettings()
    },
  },
})
